import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const CrossWithCircleIcon = ({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = '#C10606',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM15 9l-6 6M9 9l6 6"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
